// Hamburger Menu
(() => {
  const buttonHamburger = document.getElementById("js-buttonHamburger");
  const lheader = document.querySelector(".js-l-header");
  const lHeaderNav = document.querySelector(".js-l-header-nav");
  const accordionContents = document.querySelectorAll(".js-header-nav-sp-accordion-contents");

  const toggleHamburger = () => {
    const isExpanded = buttonHamburger.getAttribute("aria-expanded") === "true";
    const newState = !isExpanded;

    buttonHamburger.setAttribute("aria-expanded", newState);
    lHeaderNav.classList.toggle("is-open", newState);
    lheader.classList.toggle("is-open", newState);
    accordionContents.forEach(content => content.classList.remove("is-open"));
  };

  const closeHamburger = () => {
    buttonHamburger.setAttribute("aria-expanded", false);
    lHeaderNav.classList.remove("is-open");
    lheader.classList.remove("is-open");
  };

  buttonHamburger.addEventListener("click", toggleHamburger);

  let lastInnerWidth = window.innerWidth;
  window.addEventListener("resize", () => {
    if (buttonHamburger.getAttribute("aria-expanded") === "true") {
      if (lastInnerWidth != window.innerWidth) {
        lastInnerWidth = window.innerWidth;
        closeHamburger();
      }
    }
  });
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      if (buttonHamburger.getAttribute("aria-expanded") === "true") {
        closeHamburger();
      }
    } else if (window.performance.navigation.type == 2) {
      if (buttonHamburger.getAttribute("aria-expanded") === "true") {
        closeHamburger();
      }
    }
  });
})();

// ヘッダーとKVの高さを合わせた高さを取得
let HeaderkvHeight = () => {
  let client_h;
  if (document.querySelector(".js-kv") != null) {
    client_h = document.querySelector(".js-kv").offsetHeight + document.querySelector(".js-l-header").offsetHeight;
  } else {
    client_h = 800 + document.querySelector(".js-l-header").offsetHeight;
  }
  return client_h;
};

(() => {
  window.addEventListener("load", HeaderkvHeight);
  window.addEventListener("resize", HeaderkvHeight);
})();

// ヘッダーを縮小
(() => {
  let lheader = document.querySelector(".js-l-header");
  let lheaderNews = document.querySelector(".js-l-header-news");

  window.addEventListener("scroll", () => {
    if (lheaderNews) {
      let lheaderNewsHeight = lheaderNews.offsetHeight;
      if (window.scrollY > HeaderkvHeight()) {
        lheader.classList.add('is-news-hidden');
        lheader.style.transform = `translateY(-${lheaderNewsHeight}px)`;
      } else {
        lheader.classList.remove('is-news-hidden');
        lheader.style.transform = `translateY(0px)`;
      }
    }
  });
})();

const HeightSet = () => {
  let lheader = document.querySelector(".js-l-header");
  let lheaderNavWrap = document.querySelector(".js-l-header-nav-wrap");
  let lheaderHeight = lheader.offsetHeight;

  let lheaderNews = document.querySelector(".js-l-header-news");
  let lheaderNewsHeight = 0;
  let pt;
  if (lheaderNews) {
    lheaderNewsHeight = lheaderNews.offsetHeight;
    lheaderNavWrap.style.paddingTop = `${lheaderHeight}px`;
    pt = lheaderHeight - lheaderNewsHeight;
  }

  window.addEventListener("scroll", () => {
    if (window.scrollY > HeaderkvHeight()) {
      lheaderNavWrap.style.paddingTop = `${pt}px`;
    } else {
      lheaderNavWrap.style.paddingTop = `${lheaderHeight}px`;
    }
  });
};

(() => {
  window.addEventListener("load", HeightSet);
  window.addEventListener("resize", HeightSet);
})();




// window.addEventListener("pageshow", function (event) {
//   if (event.persisted) {
//     window.location.reload();
//   } else if (window.performance.navigation.type == 2) {
//     window.location.reload();
//   }
// });


// pc ヘッダー popupメニュー 
$(document).ready(function() {
  // ボタンをクリックしたときの処理
  $('.js-header-nav-pc-popup-toggle').on('click', function(event) {
    $(this).toggleClass('is-open');
    $(this).next('.js-header-nav-pc-popup-contents').toggleClass('is-show');
    event.stopPropagation(); // イベントの伝播を止める
  });

  // コンテンツ以外をクリックしたときの処理
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.js-header-nav-pc-popup-contents').length && !$(event.target).is('#js-header-nav-pc-popup-toggle')) {
      $('.js-header-nav-pc-popup-toggle').removeClass('is-open');
      $('.js-header-nav-pc-popup-contents').removeClass('is-show');
    }
  });
});


// sp ヘッダー アコーディオンメニュー 
$(document).ready(function() {
  $('.js-header-nav-sp-accordion-toggle').on('click', function(event) {
    $(this).toggleClass('is-open');
    $(this).next('.js-header-nav-sp-accordion-contents').toggleClass('is-open');
  });
  // ハンバーガーボタンをクリックしたときの処理
  $('#js-buttonHamburger').on('click', function(event) {
    $('js-header-nav-sp-accordion-contents').removeClass('is-open');
  });
});


